import { isString } from "underscore";

/**
 * Clamp - Forces a number to between min and max
 * @param {int} num 
 * @param {int} min 
 * @param {int} max 
 */
export function clamp(num, min, max) {
    return Math.max(Math.min(num, Math.max(min, max)), Math.min(min, max));  
}

/**
 * Round up to nearest
 * @param {int} num Number to be rounded
 * @param {int} roundTo Nearest number to round to
 */
export function roundUpToNearest(num, roundTo = 1)
{
    return Math.ceil(num / roundTo) * roundTo;
}

/**
 * Round down to nearest
 * @param {int} num Number to be rounded
 * @param {int} roundTo Nearest number to round to
 */
export function roundDownToNearest(num, roundTo = 1)
{
    return Math.floor(num / roundTo) * roundTo;
}

/**
 * toIntOrZero - Take any input and convert it to int or 0 it
 * 
 * @param {mixed} input 
 * 
 * @return {int}
 */
export function toIntOrZero(input){
    // Already an int, just return it
    if (Number.isInteger(input)) {
        return input;
    }
    if (isString(input) && input.match(/^[0-9]+$/)) {
        return parseInt(input, 10);
    }
    return 0;
}